import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import App from './App';
import store from "./store";
import { AxiosSetup } from "./utils/helpers/api.helpers";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";

AxiosSetup();

ReactDOM.render( 
    <BrowserRouter>
    <ScrollToTop />
    <Provider store = { store }>
    <App />
    </Provider>

    </BrowserRouter>,
    document.getElementById("root")
);
